import { render, staticRenderFns } from "./notices.vue?vue&type=template&id=58f248e4&scoped=true"
import script from "./notices.vue?vue&type=script&lang=js"
export * from "./notices.vue?vue&type=script&lang=js"
import style0 from "./notices.vue?vue&type=style&index=0&id=58f248e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f248e4",
  null
  
)

export default component.exports